import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const EMBEDDED_CAPACITY_REGISTER: Layer = {
  id: ConstraintsCategory.POWER_ECR,
  layerType: ConstraintsLayerType,
  title: "Power embedded capacity",
  requiredFeatureAccess: [Feature.powerLayer],
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  toggleable: true,
  group: LayerGroup.POWER,
  icon: "lt-layer-power-embedded-capacity",
  description: "Generation and storage",
  zoomConfig: {
    minVisualisationZoom: 6,
  },
  hideByDefault: true,
  layerConfig: {
    minZoom: 6,
    showTitle: true,

    rootCategory: ConstraintsCategory.POWER_ECR,
    dedupePoints: false,
    categorySchema: [{ key: "power_ecr_connected" }, { key: "power_ecr_accepted" }, { key: "power_ecr_unknown" }],
    displayBy: {
      showDropdown: true,
      attributeOptions: [
        { attribute: "primary_energy_source_group", label: "Primary energy source" },
        { attribute: "connection_voltage_class", label: "Connection voltage class" },
      ],
      categoryOption: true,
      categoryOptionLabel: "Connection status",
    },
    attributeFilters: [
      {
        attribute: "primary_energy_source_group",
        options: [
          { value: "Solar", display_name: "Solar" },
          { value: "Wind", display_name: "Wind" },
          { value: "Fossil fuel", display_name: "Fossil fuel" },
          { value: "Biofuel and biomass", display_name: "Biofuel and biomass" },
          { value: "Energy storage", display_name: "Energy storage" },
          { value: "Other", display_name: "Other" },
          { value: "Unknown", display_name: "Unknown" },
        ],
      },
      {
        attribute: "connection_voltage_class",
        options: [
          { value: "<11kv", display_name: "<11kv" },
          { value: "11-33kv", display_name: "11-33kv" },
          { value: "33-132kv", display_name: "33-132kv" },
          { value: ">132kv", display_name: ">132kv" },
          { value: "Unknown", display_name: "Unknown" },
        ],
      },
      {
        disableHatch: true,
        attribute: "licence_area_group",
        options: [
          {
            value: "National Grid Electricty Distribution",
            display_name: "National Grid Electricty Distribution",
          },
          { value: "Eastern Power Networks", display_name: "Eastern Power Networks" },
          { value: "Northern Powergrid", display_name: "Northern Powergrid" },
          { value: "Electricity North West", display_name: "Electricity North West" },
          {
            value: "South Eastern Power Power Networks",
            display_name: "South Eastern Power Power Networks",
          },
          {
            value: "Scottish and Southern Electricity Networks",
            display_name: "Scottish and Southern Electricity Networks",
          },
          { value: "SP Energy Networks", display_name: "SP Energy Networks" },
          { value: "London Power Networks", display_name: "London Power Networks" },
          { value: "Unspecified", display_name: "Unspecified" },
        ],
      },
    ],
  },
};
